import { motion } from "framer-motion";

export const QuizOption = ({ text, onClick, testId, index }) => (
  <motion.button
    data-testid={testId}
    onClick={onClick}
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: index * 0.08, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ y: -3 }}
    whileTap={{ scale: 0.98 }}
    className="w-full text-left px-6 py-5 rounded-2xl border border-[#4A6B56]/15 bg-[#F4F0E8] hover:border-[#4A6B56] hover:bg-[#E2EAE4] transition-colors duration-300 text-[#232B25] font-medium"
  >
    {text}
  </motion.button>
);
